import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsKitTypeServices = {
  //Kit Type Metadata
  addNewEIWRSKitTypeMetadata,
  updateEIWRSKitTypeMetadataData,
  deleteEIWRSKitTypeMetadataData,
  softDeleteRestoreEIWRSKitTypeMetadata,
  getEIWRSKitTypeMetadataData,
};

// Add New Kit Type Metadata
async function addNewEIWRSKitTypeMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSKitTypeMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Kit Type Metadata
async function updateEIWRSKitTypeMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSKitTypeMetadataData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Kit Type Metadata
async function softDeleteRestoreEIWRSKitTypeMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSKitTypeMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Kit Type Metadata
async function deleteEIWRSKitTypeMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSKitTypeMetadataData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Kit Type Metadata
async function getEIWRSKitTypeMetadataData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitTypeMetadataData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitTypeMetadataData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}